export const LOGGING_REQUEST = "LOGGING_REQUEST";
export const LOGGING_SUCCESS = "LOGGING_SUCCESS";
export const LOGGING_FAIL = "LOGGING_FAIL";
export const LOGOUT = "LOGOUT";

export const PRODUCTS_LOAD_REQUEST = "LOAD_PRODUCTS_REQUEST";
export const PRODUCTS_LOAD_SUCCESS = "PRODUCTS_LOAD_SUCCESS";
export const PRODUCTS_LOAD_FAIL = "PRODUCTS_LOAD_FAIL";

export const PRODUCT_SHOW_LOAD_REQUEST = "PRODUCT_SHOW_LOAD_REQUEST";
export const PRODUCT_SHOW_LOAD_SUCCESS = "PRODUCT_SHOW_LOAD_SUCCESS";
export const PRODUCT_SHOW_LOAD_FAIL = "PRODUCT_SHOW_LOAD_FAIL";

export const PRODUCT_FAVOURITE_REQUEST = "ADD_PRODUCT_REQUEST ";
export const PRODUCT_FAVOURITE_SUCCESS = "REMOVE_PRODUCT_SUCCESS";
export const PRODUCT_FAVOURITE_FAIL = "REMOVE_PRODUCT_FAIL";

export const FAVOURITE_ADD = "REMOVE_PRODUCT_ADD";
export const FAVOURITE_REMOVE = "REMOVE_PRODUCT_REMOVE";

export const ADD_PRODUCT_CART = "ADD_PRODUCT_CART";
export const REMOVE_PRODUCT_CART = "REMOVE_PRODUCT_CART";

export const INCREAMENT_QUANTITY = "INCREAMENT_QUANTITY";
export const DECREAMENT_QUANTITY = "DECREAMENT_QUANTITY";

export const SEARCH_ADD = "SEARCH_ADD";
export const SEARCH_REMOVE = "SEARCH_REMOVE";

export const REGISTER_REQUEST = "REGISTER_REQUEST"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_FAIL = "REGISTER_FAIL"